export default __webpack_public_path__ + "static/Infinity FX37-fad9915cb30c702052015df50d35d45c.jpg";